export default {
  entityName: "PaymentTerms",
  apiEndpoint: "/master/payment-terms",
  permissions: {
    view: "master:view",
    edit: "master:edit",
  },
  columns: [
    { key: "name", label: "Terms Name", sortable: true },
    { key: "code", label: "Code", sortable: true, class: () => "font-mono font-bold" },
    { key: "settlementType", label: "Settlement Type", sortable: true },
    { key: "creditLimit", label: "Credit Limit", sortable: true, formatter: (val) => val ? `₹${Number(val).toLocaleString()}` : "No Limit" },
  ],
  fields: [
    { name: "name", label: "Terms Name", type: "text", required: true, placeholder: "e.g. Net 30" },
    { name: "code", label: "Code", type: "text", required: true, uppercase: true },
    { name: "settlementType", label: "Settlement Type", type: "select", required: true, options: ["immediate", "end_of_month", "installment"] },
    { name: "dueDays", label: "Due Days", type: "number", required: true, min: 0 },
    { name: "gracePeriodDays", label: "Grace Period (Days)", type: "number", min: 0 },
    { name: "advancePercentage", label: "Advance Payment (%)", type: "number", min: 0, max: 100 },
    { name: "creditLimit", label: "Credit Limit (Max Value)", type: "number", min: 0 },
    { name: "effectiveFrom", label: "Effective From", type: "date" },
    { name: "effectiveTo", label: "Effective To", type: "date" },
  ],
  filters: [
    { name: "status", label: "Status", type: "select", options: ["active", "inactive"] },
  ],
  workflow: {
    type: "payment_terms_approval",
    enabled: true,
  },
};
